import * as moment from 'moment';
import * as jMoment from 'jalali-moment';
import {Pipe} from "@angular/core";
import {DateUtil} from "../utils/date.util";
import {TranslateService} from "../services/translate.service";

@Pipe({
    name: 'dateTimeOptimizer'
})
export class DateTimeOptimizerPipe {
    constructor(private transl: TranslateService) {}

    public transform(value: any, args?: any): any {
        const today = moment(DateUtil.now()).format('YYYY-MM-DD');
        const theDate = moment(value).format('YYYY-MM-DD');

        const format = this.transl.dir === 'rtl' ? ('jYYYY-jMM-jDD،  hh:mm A') : ('YYYY-MM-DD hh:mm A');
        if (today === theDate) {
            return moment(value).locale(this.transl.lang).format('hh:mm A');
        }
        return jMoment(value).locale(this.transl.lang).format(format);
    }
}
